import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { Address } from '@/dataV3/Common/Address'
import { AdditionalInformations } from '@/components/pages/pet-sitter/reservations/NewRequest/NewRequest'
import { AnimalData } from '@/components/PetSitter/AddAnimal/AnimalForm'

export type SignUpCallRequestAnimalSelection = { slug: 'dog' | 'cat' | 'nac'; number: number }[]

export interface SignUpCallRequestState {
  hasHydrated: boolean
  setHasHydrated: (v: boolean) => void
  address?: Address
  service?: {
    selectedService: string
    formSlots?: any[]
  }
  icon?: string
  additionalInformations: AdditionalInformations
  message?: string
  animals: AnimalData[]
  animalSelection?: SignUpCallRequestAnimalSelection
  distance: { min: number; max: number }
  setDistance: (distance: { min: number; max: number }) => void
  setAddress: (address: Address) => void
  setService: (service: { selectedService: string; formSlots?: any[] }) => void
  setIcon: (icon: string) => void
  setAdditionalInformations: (info: AdditionalInformations) => void
  setMessage: (message: string) => void
  setAnimals: (animals: AnimalData[]) => void
  setAnimalSelection: (animalSelection?: SignUpCallRequestAnimalSelection) => void
  addAnimal: (animal: AnimalData) => void
  updateAnimal: (animal: AnimalData) => void
  removeAnimal: (uuid: string) => void
  reset: () => void
}

export const useSignUpCallRequestStore = create<SignUpCallRequestState>()(
  persist(
    (set, get) => ({
      hasHydrated: false,
      setHasHydrated: (v) => set({ hasHydrated: v }),
      address: undefined,
      service: undefined,
      icon: undefined,
      additionalInformations: {
        walkBehaviors: [],
        indoorBehaviors: [],
        indoorCleanliness: undefined,
        timeAlone: undefined,
        housing: undefined,
        summary: '',
      },
      message: undefined,
      animals: [],
      animalSelection: undefined,
      distance: { min: 0, max: 20 },
      setAddress: (address) => set({ address }),
      setDistance: (distance) => set({ distance }),
      setService: (service) => set({ service }),
      setIcon: (icon) => set({ icon }),
      setAdditionalInformations: (info) => set({ additionalInformations: info }),
      setMessage: (message) => set({ message }),
      setAnimals: (animals) => set({ animals }),
      setAnimalSelection: (animalSelection) => set({ animalSelection }),
      addAnimal: (animal) => set((state) => ({ animals: [...state.animals, animal] })),
      updateAnimal: (animal) =>
        set((state) => ({ animals: state.animals.map((a) => (a.uuid === animal.uuid ? animal : a)) })),
      removeAnimal: (uuid) => set((state) => ({ animals: state.animals.filter((a) => a.uuid !== uuid) })),
      reset: () =>
        set({
          address: undefined,
          service: undefined,
          distance: undefined,
          icon: undefined,
          additionalInformations: {
            walkBehaviors: [],
            indoorBehaviors: [],
            indoorCleanliness: undefined,
            timeAlone: undefined,
            housing: undefined,
            summary: '',
          },
          animals: [],
          animalSelection: undefined,
        }),
    }),
    {
      name: 'sign-up-call-request-store',
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    },
  ),
)
